<template>
  <div>
    <PolicyPopup ref="policyPopupRef" v-model="checkedPrivacy" :show-check-box="false" :policy-content="privacyConfig.privacy_policy" @confirm-policy="handleConfirmPolicy" />
  </div>
</template>

<script>
import Vue from 'vue'
import { Toast } from 'vant'
import { privacyRead, getPrivacyConfig } from '../../api/api'

import { checkin, TypeCheckItem, GetPatient } from '../../api/api'
Vue.use(Toast)
export default {
  data() {
    return {
      patient_id: '',
      checkedPrivacy: false,
      privacyConfig: {},
    }
  },

  mounted() {
    localStorage.removeItem('alreadyTwice') //清除人脸识别缓存

    this.getPatient()
  },
  methods: {
    handleConfirmPolicy() {
      privacyRead({
        patient_id: this.patient_id
      })
        .then(() => {
          this.getPatient()
        })
        .catch(err => {
          this.$toast(err.response.data.message)
        })
    },
    async getPatient() {
      let self = this
      await checkin()
        .then(async res => {
          console.log('checkin', res)
          if (res.data) {
            this.$store.commit('setPatientOne', { patientOne: res.data })
            //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!patientOne是checkin获取的数据
            this.patient_id = res.data.id
            const { data: privacyRes } = await getPrivacyConfig()
            console.log('🚀 ~ getPatient ~ privacyRes:', privacyRes)
            if (privacyRes.is_privacy_open === '1' && !res.data.is_privacy_read) {
              this.privacyConfig = privacyRes
              this.$refs.policyPopupRef.openPolicyPopup()
              return false
            }
            if (res.data.papid) {
              //apply提交过资料
              let userInfo = this.$store.getters.getUserInfo
              userInfo.patient = res.data
              this.$store.commit('setUserInfo', userInfo)

              GetPatient({ papid: res.data.papid }).then(res => {
                console.log('GetPatient', res)
                const { patient, phase, predict, round_phase } = res.data
                this.$store.commit('setPatientInfo', res.data)
                //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!patientInfo是GetPatient获取的数据
                if (patient.receive_phase == 1 && !predict) {
                  if (!userInfo.patient.is_check) {
                    //没有人脸识别
                    console.log('没有人脸识别')
                    this.$router.replace({
                      name: 'Liveness'
                    })
                    return
                  }
                  if (!userInfo.patient.signature_image) {
                    //没签名
                    console.log('没签名')
                    this.$router.replace({
                      name: 'BeforeApply',
                      query: {
                        patientid: self.patient_id
                      }
                    })
                    return
                  }
                }

                TypeCheckItem({
                  papid: patient.id,
                  check_item_type: '知情同意书'
                })
                  .then(res => {
                    if (res.data.result.status == '审核不通过' || res.data.result.status == '未上传') {
                      if (patient.status == '初始' && patient.statusing == '初审驳回') {
                        this.$router.replace({
                          name: 'BeforeApply',
                          query: {
                            patientid: self.patient_id,
                            reason: res.data.result.reasons,
                            status: res.data.result.status
                          }
                        })
                      } else {
                        this.$router.replace({
                          name: 'Query'
                        })
                      }
                      return
                    } else {
                      this.$router.replace({
                        name: 'Query'
                      })
                    }
                  })
                  .catch(err => {
                    Toast(err.response.data.message)
                  })
              })
            } else {
              console.log('没到apply')
              //没有填写资料apply
              if (!res.data.idsn) {
                //没有实名认证
                console.log('没有实名认证')
                this.$router.replace({
                  name: 'Ocr',
                  query: {
                    patientid: res.data.id
                  }
                })
                return
                // }
                // if (!res.data.signature_image) {//没签名
                // console.log("没签名")
                //   this.$router.replace({
                //     name: "BeforeApply",
                //     query: {
                //       patientid: self.patient_id
                //     }
                //   });
                //   return
              } else {
                //有签名
                console.log('去apply')
                this.$router.replace({
                  name: 'Apply'
                })
                return
              }
            }
          } else {
            console.log('没有登陆')
            //如果没有登录1
            this.$router.replace({
              name: 'Login'
            })
            return
          }
        })
        .catch(err => {
          console.log('blank出错')
          Toast(err.response.data.message)
          this.$router.replace({
            name: 'Login'
          })
          return
        })
    }
  }
}
</script>

<style></style>
